// @flow

import type { LocaleData } from 'app/packages/pinterest-flow-types/i18n';

type LocaleLoader = () => Promise<LocaleData>;

export default function createLocaleLoader(loaderMap: { [locale: string]: LocaleLoader }) {
  return (startArgsLocale: string): Promise<LocaleData> => {
    const locale = startArgsLocale || 'en-US';
    const loader = loaderMap[locale];
    return loader ? loader() : Promise.reject(new Error(`Invalid locale ${locale}`));
  };
}
